import { useAuth } from '@/hooks/useAuth';

const Profile = () => {
  const { user } = useAuth();
  const displayName =
    [user?.first_name, user?.last_name].filter(Boolean).join(' ') ||
    user?.username ||
    user?.email ||
    'User';
  const initials =
    displayName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part[0]?.toUpperCase())
      .join('') ||
    'U';

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Profile</h1>
        <div className="space-y-6">
          <div className="flex items-center space-x-6">
            <div className="h-24 w-24 rounded-full border-4 border-primary-200 bg-gray-100 flex items-center justify-center text-2xl font-semibold text-gray-700">
              {initials}
            </div>
            <div>
              <h2 className="text-2xl font-semibold text-gray-900">{displayName}</h2>
              <p className="text-gray-600">{user?.email}</p>
            </div>
          </div>
          <div className="mt-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">User Information</h3>
            <pre className="bg-gray-50 rounded-lg p-4 overflow-auto">
              {JSON.stringify(user, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
